export default "__VITE_ASSET__BAHVZ1Ad__"